// extracted by mini-css-extract-plugin
module.exports = {"top":"LayoutTabs_top__1Z2tm","main":"LayoutTabs_main__1BtN-","limit":"LayoutTabs_limit__3H8eT"};